'use strict';

(function () {
  'use strict';

  angular.module('msOnboarding').component('thanks', {
    bindings: {
      programs: '<'
    },
    templateUrl: 'onboarding/pages/thanks.html',
    controller: ['$log', '$stateParams', 'userSvc', 'onboardingRouter', function ($log, $stateParams, userSvc, onboardingRouter) {
      var vm = this;
      vm.next = next;
      vm.show = false;
      vm.appMode = 'STANDARD';
      vm.$onInit = init;

      /////////////////////

      function init() {
        userSvc.getUser().then(function (user) {
          vm.user = user;
          vm.appMode = vm.user && vm.user.accessCode && vm.user.accessCode.applicationMode ? vm.user.accessCode.applicationMode.name : 'STANDARD';
        });

        if (vm.programs.length <= 1) {
          onboardingRouter.goToNextStep($stateParams, {
            name: 'onboarding.survey.overlay'
          });
        } else {
          // Default set first program id
          vm.selectedProgramId = vm.programs[0].id;
          vm.show = true;
        }
      }

      function next(programId) {
        var currentProgram = _.find(vm.programs, { id: programId });
        var user = {
          wellnessProgram: currentProgram.shortName
        };
        $log.debug('user: ', user);
        userSvc.saveUser(user);
        onboardingRouter.goToNextStep($stateParams, {
          name: 'onboarding.survey.overlay'
        });
      }
    }]
  });
})();